import { createSelector } from '@ngrx/store'

export const getImageTypesState = createSelector(
  (state: any) => state.shared,
  (state: any) => state.get('imageTypes'),
)

export const getPropertiesState = createSelector(
  (state: any) => state.properties,
  (state: any) => state.get('list'),
)

export const getPropertyState = createSelector(
  (state: any) => state.properties,
  (state: any) => state.get('property'),
)

export const isFeaturesCalculatingState = (parent: string) =>
  createSelector(
    (state: any) => state.properties,
    (state: any) => state.getIn([parent, 'isFeaturesCalculating']),
  )

export const getGenerateRDNsState = createSelector(
  (state: any) => state.properties,
  (state: any) => state.get('generateRDNs'),
)

export const getGenerateCommercialLicensesState = createSelector(
  (state: any) => state.properties,
  (state: any) => state.get('generateCommercialLicenses'),
)

export const getCreatePropertyState = createSelector(
  (state: any) => state.properties,
  (state: any) => state.get('createProperty'),
)

export const getActiveFormState = createSelector(
  (state: any) => state.properties,
  (state: any) => state.get('activeForm'),
)

export const getPropertySettingsState = createSelector(
  (state: any) => state.properties,
  (state: any) => state.get('settings'),
)

export const getPropertyPaymentsState = createSelector(
  (state: any) => state.properties,
  (state: any) => state.get('payments'),
)

export const isPaymentReportGeneratingState = createSelector(
  (state: any) => state.properties,
  (state: any) => state.getIn(['generatePaymentReport', 'isLoading']),
)

export const isPropertyReportGeneratingState = createSelector(
  (state: any) => state.properties,
  (state: any) => state.getIn(['generatePropertyReport', 'isLoading']),
)

export const isPropertyBusinessReportGeneratingState = createSelector(
  (state: any) => state.properties,
  (state: any) => state.getIn(['generatePropertyBusinessReport', 'isLoading']),
)

export const isPaymentTaxpayerReportGeneratingState = createSelector(
  (state: any) => state.properties,
  (state: any) => state.getIn(['generatePaymentTaxpayerReport', 'isLoading']),
)

export const isBusinessLicenceGeneratingState = createSelector(
  (state: any) => state.properties,
  (state: any) => state.getIn(['generateBusinessLicenceReport', 'isLoading']),
)
